import { TokenManager as e } from "../../tokenManager.js";
import { AuthManager as t } from "../AuthManager.js";
let r = null;
let n = 0;
const s = () => {
  t.get().signoutRedirect();
}, o = [401], i = (i2) => {
  i2.interceptors.response.use((e2) => e2, async (c) => {
    var _a;
    const a = (_a = c.response) == null ? void 0 : _a.status, u = c.config;
    if (!o.includes(a)) return Promise.reject(c);
    if (u._retryCount || (u._retryCount = 0), u._retryCount >= 3) return s(), Promise.reject(c);
    u._retryCount++;
    try {
      const o2 = await (() => {
        if (!r) {
          const o3 = t.get();
          r = o3.signinSilent().then((t2) => {
            const r2 = t2 == null ? void 0 : t2.access_token;
            return e.setState(r2), n = 0, r2;
          }).catch((e2) => {
            throw n += 1, n >= 3 && s(), e2;
          }).finally(() => {
            r = null;
          });
        }
        return r;
      })();
      return u.headers = u.headers ?? {}, u.headers.Authorization = `Bearer ${o2}`, i2(u);
    } catch (e2) {
      return Promise.reject(e2);
    }
  });
};
export {
  i as setupUnauthorizedInterceptor
};
//# sourceMappingURL=unauthorizedInterceptor.js.map
